
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },

  computed: {
    styledLeftColumn() {
      return {
        'lg:justify-start': this.blok.left_column_alignment === 'start',
        'lg:justify-center': this.blok.left_column_alignment === 'center',
        'lg:justify-end': this.blok.left_column_alignment === 'end',
        'justify-start': this.blok.left_column_alignment_mobile === 'start',
        'justify-center': this.blok.left_column_alignment_mobile === 'center',
        'justify-end': this.blok.left_column_alignment_mobile === 'end',

        'items-center': this.blok.left_column_center,
      }
    },
    styledRightColumn() {
      return {
        'lg:justify-start': this.blok.right_column_alignment === 'start',
        'lg:justify-center': this.blok.right_column_alignment === 'center',
        'lg:justify-end': this.blok.right_column_alignment === 'end',
        'justify-start': this.blok.right_column_alignment_mobile === 'start',
        'justify-center': this.blok.right_column_alignment_mobile === 'center',
        'justify-end': this.blok.right_column_alignment_mobile === 'end',

        'items-center': this.blok.right_column_center,
      }
    },
  },
}
